export enum VriChatLogMessage {
  TURN_UPDATED = 'Turn updated',
}
